import { render, staticRenderFns } from "./PresentLevelsResourceDocs.vue?vue&type=template&id=33f1be07&scoped=true"
import script from "./PresentLevelsResourceDocs.vue?vue&type=script&lang=js"
export * from "./PresentLevelsResourceDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f1be07",
  null
  
)

export default component.exports